"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RUNE_OUTBOUND_TRANSACTION_FEE_CRYPTO_HUMAN = void 0;
const bignumber_1 = require("../utils/bignumber");
// TODO: read from https://daemon.thorchain.shapeshift.com/lcd/thorchain/constants
exports.RUNE_OUTBOUND_TRANSACTION_FEE_CRYPTO_HUMAN = (0, bignumber_1.bn)('0.02');
